
function in_array(array, num) {
    let filter = array.filter(el=>el.code === num);
    if(filter.length>0) return true;
    return false;
}
 
export function get_rand(array) {
     var rand = Math.floor(1000 + Math.random() * 9000);
     if(!in_array(array, rand)) {
        return rand;
     }
     return get_rand(array);
 }